<div *ngIf="loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-table [rows]="rows" [columns]="columns" [batch]="false" [actions]="tableActions" (changeBatch)="onChangeBatch($event)"
  (action)="onAction($event)"></app-table>

<ng-template #formModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ networkModel.id ? 'Edit' : 'Create' }} network</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-network-form [model]="networkModel" (onAfterSave)="onAfterSave()" [backButtonShow]="false"></app-network-form>
  </div>
</ng-template>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>
